import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import debounce from 'lodash/debounce';
import './mobile-menu';

gsap.registerPlugin(ScrollTrigger);

// Scroll-based active navigation.
const activeProgress = document.querySelector('.site-header__active-progress');
let navigationItems = document.querySelectorAll('.site-header__nav-link');

// Remove last navigation item ("Stay Informed").
navigationItems = Array.from(navigationItems).slice(0, navigationItems.length - 1);

// Set active progress bar.
const setActiveProgress = (defaultActiveItem = null) => {
  let activeItem = defaultActiveItem;
  if (!activeItem || typeof activeItem === 'undefined') {
    activeItem = document.querySelector('.site-header__nav-link--active');
  }

  if (activeItem) {
    // Set applicable nav progress.
    const { left, width } = activeItem.getBoundingClientRect();
    const windowWidth = document.body.clientWidth;
    activeProgress.style.width = `${((left + (width / 2)) / windowWidth) * 100}%`;
  } else {
    activeProgress.style.width = '0';
  }
};

// Set active nav link + leading passed items.
const setActiveNavItem = (items, activeIndex) => {
  const itemsArray = Array.from(items);
  const activeItem = itemsArray[activeIndex];

  // Remove all other active items.
  itemsArray.forEach((item) => {
    item.classList.remove('site-header__nav-link--active');
    item.classList.remove('site-header__nav-link--passed');
  });

  // Update nav progress.
  setActiveProgress(activeItem);

  // Update passed items.
  const passedItems = activeIndex < 0 ? [] : itemsArray.slice(0, activeIndex);
  passedItems.forEach((item) => {
    item.classList.add('site-header__nav-link--passed');
  });

  // If we're back at the top of the page, no active items.
  if (activeIndex < 0) {
    return;
  }

  // Set current item to active.
  itemsArray[activeIndex].classList.add('site-header__nav-link--active');
};

// Resize event: Make sure active progress respond to window resizes.
window.addEventListener('resize', debounce(() => {
  setActiveProgress();
}, 500));

// Navigation links.
setTimeout(() => {
  Array.from(navigationItems).forEach((navItem, index) => {
    // Scroll-based active navigation.
    const correspondingSection = document.getElementById(navItem.hash.slice(1));
    if (correspondingSection) {
      ScrollTrigger.create({
        trigger: correspondingSection,
        start: 'top top',
        onEnter() {
          setActiveNavItem(navigationItems, index);
        },
        onLeaveBack() {
          setActiveNavItem(navigationItems, index - 1);
        },
      });
    }
  });
}, 100);
